import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from '@/pages/Home';
import { Projects } from '@/pages/Projects';
import { About } from '@/pages/About';
import { ProjectDetails } from '@/pages/ProjectDetails';
import { NotFound } from '@/pages/NotFound';
import './index.css';

import { Header } from '@/components/common/Header';
import { Footer } from '@/components/common/Footer';
import { ScrollToTopButton } from '@/components/common/ScrollToTopButton';
import { SkipLink } from '@/components/common/SkipLink';
import { ScrollToTop } from '@/components/common/ScrollToTop';
import { ThemeProvider } from '@/context/ThemeContext';
import { ToastProvider } from '@/context/ToastContext';

import { ROUTES } from './config/routes';



function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <BrowserRouter>
          <div className="app-wrapper">
            <ScrollToTop />
            <SkipLink />
            <div className="ambient-glow">
              <div className="mouse-glow" />
            </div>
            <Header />
            <main className="app-main" id="main-content">
              <Routes>
                <Route path={ROUTES.HOME} element={<Home />} />
                <Route path={ROUTES.PROJECTS.ROOT} element={<Projects />} />
                <Route path={ROUTES.PROJECTS.DETAILS} element={<ProjectDetails />} />
                <Route path={ROUTES.ABOUT} element={<About />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
            <ScrollToTopButton />
          </div>
        </BrowserRouter>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
